"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateWidgetData = exports.userOptions = exports.userDefinedOptions = exports.systemOptions = exports.systemDefinedOptions = exports.logicalFunctionOptionsDefault = exports.infographicAggregationField = exports.ignoredPieInfographicFieldType = exports.ignoredInfographicFieldType = exports.ignoredBarChartInfographicFieldType = exports.graphType = exports.getIOption = exports.getFilteredFieldsnameAndIdForLookup = exports.getFilteredFieldsnameAndIdForInfographics = exports.getFieldTypeByData = exports.getFieldTitle = exports.getDropdownOptions = exports.getDataDefineOptions = exports.getChartColor = exports.generateYearOptions = exports.generateUniqueId = exports.fieldoptions = exports.fieldConstraint = exports.fieldAdditionalOptions = exports.emptyWidgetData = exports.emptyFieldCondition = exports.dropdownDataVerifier = exports.displaySuccessMessage = exports.displayErrorMessage = exports.dataVerifier = exports.constraintConfigs = exports.allConstraint = exports.YTypes = exports.LogicalFunctionOptions = exports.ConditionType = void 0;
var _interface = require("./interface.js");
var _toast = require("../../atoms/Toast/toast.js");
var _interface2 = require("../../atoms/Toast/interface.js");
var _CommonUtility = require("../../../utils/CommonUtility.js");
var _Charts = require("../Charts/index.js");
const generateUniqueId = (idType, prefix = '') => {
  const uniqueIdPrefix = prefix ? prefix + '-' : '';
  const uniqueId = uniqueIdPrefix + idType + (0, _CommonUtility.generateUuidv4)();
  return uniqueId;
};
exports.generateUniqueId = generateUniqueId;
const graphType = exports.graphType = [_Charts.ChartType.BARCHART, _Charts.ChartType.AREACHART, _Charts.ChartType.LINECHART, _Charts.ChartType.PIECHART];
const emptyWidgetData = exports.emptyWidgetData = {
  row: 1,
  column: 1,
  name: 'Chart title',
  description: 'Chart Description',
  localId: '63c6913ac62f9822f5797e12-widgetId',
  formId: '',
  type: _Charts.ChartType['NOCHART'],
  // isEmptyWidget: boolean, //backend has to support it
  xAxis: {
    initialValue: 1,
    perUnit: 1
  },
  yAxis: {
    type: 'string',
    initialValue: 1,
    perUnit: 1
  },
  filterSettings: {
    selectFields: [],
    conditions: [],
    logicalOperator: 'OR'
  }
};
const ignoredInfographicFieldType = exports.ignoredInfographicFieldType = [_interface.FormFieldTypes.TEXT_AREA, _interface.FormFieldTypes.PAYMENT, _interface.FormFieldTypes.FILE_UPLOAD, _interface.FormFieldTypes.SECTION, _interface.FormFieldTypes.DESCRIPTION, _interface.FormFieldTypes.PAGE_BREAK, _interface.FormFieldTypes.DECIMAL, _interface.FormFieldTypes.BLANK_BOX, _interface.FormFieldTypes.CHECK_BOX];
const emptyFieldCondition = exports.emptyFieldCondition = {
  fieldTitle: '',
  fieldLocalId: '',
  condition: '',
  value: ''
};
const displaySuccessMessage = (content, onClose) => {
  return (0, _toast.toast)(_interface2.ToastTypeEnum.success, {
    title: content,
    description: '',
    onClose: onClose
  });
};
exports.displaySuccessMessage = displaySuccessMessage;
const displayErrorMessage = (content, onClose) => {
  return (0, _toast.toast)(_interface2.ToastTypeEnum.error, {
    title: content,
    description: '',
    onClose: onClose
  });
};
exports.displayErrorMessage = displayErrorMessage;
const validateWidgetData = widgetData => {
  let isValidated = true;
  const requiredFieldinWigetData = ['localId', 'row', 'column', 'name', 'description', 'type'];
  const removeEmptyData = data => {
    const updatedData = {};
    Object.keys(data).forEach(function (key) {
      if (data[key] && typeof data[key] === 'object') {
        updatedData[key] = removeEmptyData(data[key]);
      } else if (data[key] != '') {
        updatedData[key] = data[key];
      }
    });
    return updatedData;
  };
  const updatedWidgetData = removeEmptyData(widgetData);
  const validateFieldRuleData = (requiredFieldinData, widgetData) => {
    const filteredData = requiredFieldinData?.filter(data => {
      if (typeof data == 'string' && widgetData[data]) return false;
      if (typeof data !== 'string') {
        const {
          key,
          subdata
        } = data;
        if (widgetData[key]) {
          Object.keys(widgetData[key]).forEach(function (value, index) {
            validateFieldRuleData(subdata, widgetData[data.key][index]);
          });
          return false;
        }
        if (filteredData.length > 0) {
          isValidated = false;
        }
      }
      return true;
    });
  };
  validateFieldRuleData(requiredFieldinWigetData, updatedWidgetData);

  // remaining validation will be done after BE is completed
  return isValidated;
};
exports.validateWidgetData = validateWidgetData;
const ignoredBarChartInfographicFieldType = exports.ignoredBarChartInfographicFieldType = [_interface.FormFieldTypes.FILE_UPLOAD, _interface.FormFieldTypes.TEXT_AREA, _interface.FormFieldTypes.SECTION, _interface.FormFieldTypes.PAYMENT //CONFIG NOT ADDED IN BE
];
const ignoredPieInfographicFieldType = exports.ignoredPieInfographicFieldType = [_interface.FormFieldTypes.TEXT_AREA, _interface.FormFieldTypes.PAYMENT, _interface.FormFieldTypes.DATE_INPUT, _interface.FormFieldTypes.TIME_PICKER, _interface.FormFieldTypes.DATE_TIME_PICKER, _interface.FormFieldTypes.FILE_UPLOAD];
const infographicAggregationField = exports.infographicAggregationField = [_interface.FormFieldTypes.TEXT_INPUT, _interface.FormFieldTypes.DROPDOWN, _interface.FormFieldTypes.MULTIPLE_CHOICES, _interface.FormFieldTypes.TEXT_AREA, _interface.FormFieldTypes.DATE_INPUT, _interface.FormFieldTypes.TIME_PICKER, _interface.FormFieldTypes.LINEAR_SCALING, _interface.FormFieldTypes.FILE_UPLOAD, _interface.FormFieldTypes.RATING, _interface.FormFieldTypes.DATE_TIME_PICKER, _interface.FormFieldTypes.CHECK_BOX, _interface.FormFieldTypes.DECIMAL, _interface.FormFieldTypes.DECISION_BOX, _interface.FormFieldTypes.PAGE_BREAK, _interface.FormFieldTypes.PAYMENT, _interface.FormFieldTypes.SECTION];
const getFilteredFieldsnameAndIdForInfographics = (fieldsMap = {}, fieldIdsIgnore = [], fieldTypesToIgnore = []) => {
  const filteredFieldOptions = [];
  Object.keys(fieldsMap)?.map(key => {
    const fieldData = fieldsMap[key];
    const {
      title = '',
      isSection,
      fieldType = '',
      fields
    } = fieldData;
    const checkIsSection = isSection || fields?.length > 1 || false;
    if (!fieldIdsIgnore.includes(key) && !checkIsSection && !fieldTypesToIgnore.includes(fieldType)) {
      filteredFieldOptions.push({
        content: title || 'Untitled field',
        value: key
      });
    }
  });
  return filteredFieldOptions;
};
exports.getFilteredFieldsnameAndIdForInfographics = getFilteredFieldsnameAndIdForInfographics;
const getFilteredFieldsnameAndIdForLookup = (fieldsMap = {}, fieldIdsIgnore = [], fieldTypesToIgnore = []) => {
  const filteredFieldOptions = [];
  Object.keys(fieldsMap)?.map(key => {
    const fieldData = fieldsMap[key];
    const {
      title = '',
      isSection,
      fieldType = '',
      fields
    } = fieldData;
    const checkIsSection = isSection || fields?.length > 1 || false;
    if (!fieldIdsIgnore.includes(key) && !checkIsSection && !fieldTypesToIgnore.includes(fieldType)) {
      filteredFieldOptions.push({
        content: title || 'Untitled field',
        value: key,
        fieldType: fieldType
      });
    }
  });
  return filteredFieldOptions;
};
exports.getFilteredFieldsnameAndIdForLookup = getFilteredFieldsnameAndIdForLookup;
const getFieldTitle = (fieldsMap, fieldId) => {
  const fieldsData = fieldsMap?.[fieldId] || {
    title: ''
  };
  return fieldsData?.title ?? '';
};
exports.getFieldTitle = getFieldTitle;
const getChartColor = count => {
  const colors = [];
  while (colors.length < count) {
    const color = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    if (isTooDarkORtooLight(color) && !colors.includes(color) && color.length === 7) {
      colors.push(color);
    }
  }
  return colors;
};
exports.getChartColor = getChartColor;
const isTooDarkORtooLight = hexcolor => {
  const r = parseInt(hexcolor.substr(1, 2), 16);
  const g = parseInt(hexcolor.substr(3, 2), 16);
  const b = parseInt(hexcolor.substr(4, 2), 16);
  const color = (r * 299 + g * 587 + b * 114) / 1000;
  return color > 80 && color < 160;
};
const commonFieldConstraint = {
  IS: 'IS',
  IS_NOT: 'IS_NOT',
  IS_EMPTY: 'IS_EMPTY',
  IS_NOT_EMPTY: 'IS_NOT_EMPTY',
  CONTAINS: 'CONTAINS',
  NOT_CONTAINS: 'NOT_CONTAINS'
};
const constraintConfigs = exports.constraintConfigs = {
  TEXT_INPUT: Object.assign({}, commonFieldConstraint, {
    CONTAINS: 'CONTAINS',
    NOT_CONTAINS: 'NOT_CONTAINS',
    STARTS_WITH: 'STARTS_WITH',
    ENDS_WITH: 'ENDS_WITH'
  }),
  SEQUENCE: Object.assign({}, commonFieldConstraint, {
    CONTAINS: 'CONTAINS',
    NOT_CONTAINS: 'NOT_CONTAINS',
    STARTS_WITH: 'STARTS_WITH',
    ENDS_WITH: 'ENDS_WITH'
  }),
  TEXT_AREA: Object.assign({}, commonFieldConstraint, {
    CONTAINS: 'CONTAINS',
    NOT_CONTAINS: 'NOT_CONTAINS',
    STARTS_WITH: 'STARTS_WITH',
    ENDS_WITH: 'ENDS_WITH'
  }),
  CURRENCY: Object.assign({}, commonFieldConstraint, {
    LESS_THAN: 'LESS_THAN',
    GREATER_THAN: 'GREATER_THAN',
    LESS_THAN_OR_EQUAL_TO: 'LESS_THAN_OR_EQUAL_TO',
    GREATER_THAN_OR_EQUAL_TO: 'GREATER_THAN_OR_EQUAL_TO'
    // BETWEEN: "BETWEEN",
    // MAXIMUM_DIGIT_LENGTH = "MAXIMUM_DIGIT_LENGTH",
  }),
  RATING: Object.assign({}, commonFieldConstraint, {
    LESS_THAN: 'LESS_THAN',
    GREATER_THAN: 'GREATER_THAN',
    LESS_THAN_OR_EQUAL_TO: 'LESS_THAN_OR_EQUAL_TO',
    GREATER_THAN_OR_EQUAL_TO: 'GREATER_THAN_OR_EQUAL_TO'
    // BETWEEN: "BETWEEN",
    // MAXIMUM_DIGIT_LENGTH = "MAXIMUM_DIGIT_LENGTH",
  }),
  DATE_INPUT: Object.assign({}, commonFieldConstraint, {
    LESS_THAN: 'LESS_THAN',
    GREATER_THAN: 'GREATER_THAN'
    // BETWEEN: "BETWEEN",
  }),
  DATE_TIME_PICKER: Object.assign({}, commonFieldConstraint, {
    LESS_THAN: 'LESS_THAN',
    GREATER_THAN: 'GREATER_THAN'
    // BETWEEN: "BETWEEN",
  }),
  NUMBER_INPUT: Object.assign({}, commonFieldConstraint, {
    IS: 'Is',
    IS_NOT: 'Is Not',
    LESS_THAN: 'LESS_THAN',
    GREATER_THAN: 'GREATER_THAN',
    LESS_THAN_OR_EQUAL_TO: 'LESS_THAN_OR_EQUAL_TO',
    GREATER_THAN_OR_EQUAL_TO: 'GREATER_THAN_OR_EQUAL_TO',
    BETWEEN: 'BETWEEN'
  }),
  TIME_PICKER: Object.assign({}, commonFieldConstraint, {
    LESS_THAN: 'LESS_THAN',
    GREATER_THAN: 'GREATER_THAN'
    // BETWEEN: "BETWEEN",
  }),
  DROPDOWN: Object.assign({}, commonFieldConstraint, {
    STARTS_WITH: 'STARTS_WITH',
    ENDS_WITH: 'ENDS_WITH'
    // Other Choice Is Not Empty
    // Is Any Of
    // Is None Of
  }),
  MULTIPLE_CHOICES: Object.assign({}, commonFieldConstraint, {
    CONTAINS: 'CONTAINS',
    NOT_CONTAINS: 'NOT_CONTAINS'
    //   Contains Any Of
    // Contains All Of
    // Contains None Of
  }),
  LINEAR_SCALING: {
    IS: 'Is',
    IS_NOT: 'Is Not',
    LESS_THAN: 'LESS_THAN',
    GREATER_THAN: 'GREATER_THAN',
    LESS_THAN_OR_EQUAL_TO: 'LESS_THAN_OR_EQUAL_TO',
    GREATER_THAN_OR_EQUAL_TO: 'GREATER_THAN_OR_EQUAL_TO'
    // BETWEEN: "BETWEEN",
  },
  PAYMENT: {
    IS: 'Is',
    IS_NOT: 'Is Not',
    LESS_THAN: 'LESS_THAN',
    GREATER_THAN: 'GREATER_THAN',
    LESS_THAN_OR_EQUAL_TO: 'LESS_THAN_OR_EQUAL_TO',
    GREATER_THAN_OR_EQUAL_TO: 'GREATER_THAN_OR_EQUAL_TO'
    // BETWEEN: "BETWEEN",
  },
  CALCULATIVE: {
    IS: 'Is',
    IS_NOT: 'Is Not',
    LESS_THAN: 'LESS_THAN',
    GREATER_THAN: 'GREATER_THAN',
    LESS_THAN_OR_EQUAL_TO: 'LESS_THAN_OR_EQUAL_TO',
    GREATER_THAN_OR_EQUAL_TO: 'GREATER_THAN_OR_EQUAL_TO'
  },
  CHECK_BOX: {
    IS: 'Is'
  },
  FILE_UPLOAD: {
    IS_EMPTY: 'IS_EMPTY',
    IS_NOT_EMPTY: 'IS_NOT_EMPTY'
  },
  LOOKUP: Object.assign({}, commonFieldConstraint)
};
let allConstraint = exports.allConstraint = /*#__PURE__*/function (allConstraint) {
  allConstraint["IS"] = "IS";
  allConstraint["IS_NOT"] = "IS_NOT";
  allConstraint["IS_EMPTY"] = "IS_EMPTY";
  allConstraint["IS_NOT_EMPTY"] = "IS_NOT_EMPTY";
  allConstraint["LESS_THAN"] = "LESS_THAN";
  allConstraint["GREATER_THAN"] = "GREATER_THAN";
  allConstraint["LESS_THAN_OR_EQUAL_TO"] = "LESS_THAN_OR_EQUAL_TO";
  allConstraint["GREATER_THAN_OR_EQUAL_TO"] = "GREATER_THAN_OR_EQUAL_TO";
  allConstraint["MAXIMUM_DIGIT_LENGTH"] = "MAXIMUM_DIGIT_LENGTH";
  allConstraint["CONTAINS"] = "CONTAINS";
  allConstraint["NOT_CONTAINS"] = "NOT_CONTAINS";
  allConstraint["STARTS_WITH"] = "STARTS_WITH";
  allConstraint["ENDS_WITH"] = "ENDS_WITH";
  allConstraint["MAXIMUM_TEXT_LENGTH"] = "MAXIMUM_TEXT_LENGTH";
  return allConstraint;
}({});
const fieldConstraint = fieldType => {
  const constraintData = constraintConfigs[fieldType];
  const constraint = constraintData ? constraintConfigs[fieldType] || fieldType ? constraintConfigs[fieldType] : commonFieldConstraint : commonFieldConstraint;
  const inputConstraint = Object.keys(constraint).map(key => ({
    content: _interface.allConstraintNames[key],
    value: key
  }));
  return inputConstraint;
};
exports.fieldConstraint = fieldConstraint;
const getDropdownOptions = options => {
  const DropDownoptions = Object.keys(options)?.map(key => ({
    value: options[key]?.optionKey || options[key]?.optionKey || '',
    content: options[key]?.optionValue || options[key]?.optionValue || ''
  }));
  return DropDownoptions;
};
exports.getDropdownOptions = getDropdownOptions;
const dataVerifier = (fieldType, _data) => {
  switch (fieldType) {
    case _interface.FormFieldTypes.DROPDOWN:
      return dropdownDataVerifier(_data);
  }
};
exports.dataVerifier = dataVerifier;
const dropdownDataVerifier = _data => {
  if (typeof _data !== 'object' || typeof _data === 'object' && !Array.isArray(_data)) return [];
  return _data.filter(_dropdownData => _dropdownData.optionKey);
};
exports.dropdownDataVerifier = dropdownDataVerifier;
const logicalFunctionOptionsDefault = exports.logicalFunctionOptionsDefault = [{
  optionKey: 'Min',
  checked: false
}, {
  optionKey: 'Avg',
  checked: false
}, {
  optionKey: 'Count',
  checked: false
}, {
  optionKey: 'Max',
  checked: false
}, {
  optionKey: 'Sum',
  checked: false
}, {
  optionKey: 'Distinct',
  checked: false
}];
const LogicalFunctionOptions = exports.LogicalFunctionOptions = [{
  optionName: 'Min',
  optionValue: 'min'
}, {
  optionName: 'Max',
  optionValue: 'max'
}, {
  optionName: 'Avg',
  optionValue: 'avg'
}, {
  optionName: 'Sum',
  optionValue: 'sum'
}, {
  optionName: 'Count',
  optionValue: 'count'
}, {
  optionName: 'Distinct',
  optionValue: 'distinct'
}];
let YTypes = exports.YTypes = /*#__PURE__*/function (YTypes) {
  YTypes["RESPONSE_COUNT"] = "response-count";
  YTypes["FIELD"] = "field";
  return YTypes;
}({});
const fieldoptions = exports.fieldoptions = [{
  optionKey: 'all',
  optionValue: 'All'
}, {
  optionKey: 'custom',
  optionValue: 'Custom'
}];
let ConditionType = exports.ConditionType = /*#__PURE__*/function (ConditionType) {
  ConditionType["system_fields"] = "system_fields";
  ConditionType["user_field"] = "user_field";
  ConditionType["form_field"] = "form_field";
  ConditionType["data_field"] = "data_field";
  ConditionType["custom_field"] = "custom_field";
  ConditionType["user_attributes"] = "user_attributes";
  return ConditionType;
}({});
const fieldAdditionalOptions = exports.fieldAdditionalOptions = ['createdBy', 'createdDate', 'lastUpdatedBy', 'updatedDate', 'makerLevel', 'makerEmail', 'updaterLevel', 'updaterEmail', 'userId', 'username', 'phoneNumber', 'email'];
const systemOptions = exports.systemOptions = [{
  value: 'createdBy',
  content: 'Created by'
},
// {
// 	value: 'createdDate',
// 	content: 'Created on',
// },
{
  value: 'lastUpdatedBy',
  content: 'Modified by'
}, {
  value: 'makerLevel',
  content: 'Maker Level'
}, {
  value: 'makerEmail',
  content: 'Maker Email'
}, {
  value: 'updaterLevel',
  content: 'Updater Level'
}, {
  value: 'updaterEmail',
  content: 'Updater Email'
}

// {
// 	value: 'updatedDate',
// 	content: 'Modified on',
// },
];
const systemDefinedOptions = exports.systemDefinedOptions = {
  value: ConditionType.system_fields,
  content: 'System Fields',
  options: systemOptions
};
const userOptions = exports.userOptions = [{
  value: 'userId',
  content: 'User id'
}, {
  value: 'username',
  content: 'Name'
}, {
  value: 'email',
  content: 'Email'
}, {
  value: 'phoneNumber',
  content: 'Mobile'
}];
const userDefinedOptions = exports.userDefinedOptions = {
  value: ConditionType.user_field,
  content: 'User Fields',
  options: userOptions
};
const getDataDefineOptions = dataDefineOption => {
  const dataDefinedOptions = {
    value: ConditionType.data_field,
    content: 'Data Fields',
    options: dataDefineOption
  };
  return dataDefinedOptions;
};
exports.getDataDefineOptions = getDataDefineOptions;
const getIOption = (valueToFind, options) => {
  for (const option of options) {
    if (option.value === valueToFind) {
      return option;
    }
  }
  return null;
};
exports.getIOption = getIOption;
const getFieldTypeByData = type => {
  let fieldType = _interface.FormFieldTypes.TEXT_INPUT;
  switch (type) {
    case 'createdon':
    case 'modifiedon':
      fieldType = _interface.FormFieldTypes.DATE_INPUT;
      break;
    case 'makerLevel':
    case 'updaterLevel':
      fieldType = _interface.FormFieldTypes.NUMBER_INPUT;
      break;
    case 'makerEmail':
    case 'updaterEmail':
      fieldType = _interface.FormFieldTypes.TEXT_INPUT;
      break;
  }
  return fieldType;
};
exports.getFieldTypeByData = getFieldTypeByData;
const generateYearOptions = (numYears, year, noOfHidingYearsFromCurrentYear) => {
  const baseYear = year ? Number(year) : new Date().getFullYear();
  const options = [];
  const updatedYear = Number(numYears);
  const yearsToHide = Number(noOfHidingYearsFromCurrentYear) || 0;
  for (let i = yearsToHide; i < updatedYear + yearsToHide; i++) {
    const startYear = baseYear - i;
    const endYear = startYear + 1;
    const yearLabel = `${startYear}-${String(endYear).slice(2)}`;
    options.push({
      value: yearLabel,
      content: yearLabel
    });
  }
  return options;
};
exports.generateYearOptions = generateYearOptions;